import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getStatusComment',
    standalone: false
})
export class GetStatusCommentPipe implements PipeTransform {

  // Note: statusComment isn't always required even for 'Other' reason
  transform(statusReason: string[], statusComment?: string): string {
    if (!(statusReason instanceof Array)) {
      statusReason = [];
    }

    return statusReason.map(reason => reason === 'Other' && !!statusComment ? `Other - ${statusComment}` : reason).join(', ');
  }

}
